import React, { useState } from "react";
import { Col, Image, Modal, Row, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import "../../../assets/style/table/deals.scss";
import { storeProductSelector } from "../../../services/selector/index.";
import {
  IconArrowDown,
  IconArrowTop,
  IconSave,
  IconSpin,
  IconXmark,
} from "../../../assets/icon";
import { useMemo } from "react";
import TranslateText from "../TranslateText";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { formatPrice } from "../../../utils/functionCommon";
import {
  deleteItemPin,
  setValueDeleteConfig,
  updatePin,
} from "../../../services/slice/DealSlice";
import BaseButton from "../Button/BaseButton";
import {
  deleteProductPin,
  getDataFirstPageStore,
  setOpenModalConfirm,
  updateProductPin,
} from "../../../services/slice/StoreSlice";
import InputSearchBox from "../Input/InputSearchBox";

const TableConfigPageOneStore = () => {
  const { t } = useTranslation();
  const storeState = useSelector(storeProductSelector);
  const { dataBasePageOne, refetchConfig, isLoading } = storeState;
  const [dataUpdate, setDataUpDate] = useState([]);
  const dispatch = useDispatch();
  const [dataBackup, setDataBackup] = useState([...dataBasePageOne]);
  const [searchText, setSearchText] = useState("");
  useEffect(() => {
    dispatch(getDataFirstPageStore({ search: searchText }));
  }, [searchText]);
  useEffect(() => {
    if (storeState.callBackRequest) {
      dispatch(getDataFirstPageStore({ search: "" }));
    }
  }, [dispatch, storeState.callBackRequest]);
  useEffect(() => {
    // if (dataBasePageOne.length) {
    setDataBackup(dataBasePageOne);
    // }
  }, [dataBasePageOne]);
  const handleSaveConfig = () => {
    dispatch(updateProductPin(dataUpdate));
  };
  const handleSortDown = (value) => {
    let newData = [...dataBackup];
    const itemIndex = newData.findIndex((item) => item.id === value.id);
    if (itemIndex !== -1 && itemIndex < newData.length - 1) {
      [newData[itemIndex], newData[itemIndex + 1]] = [
        newData[itemIndex + 1],
        newData[itemIndex],
      ];
      newData = newData.map((item, index) => {
        return {
          ...item,
          index: index + 1,
        };
      });
      setDataBackup(newData);
    }
  };
  const handleSortUp = (value) => {
    let newData = [...dataBackup];
    const itemIndex = newData.findIndex((item) => item.id === value.id);
    if (itemIndex > 0) {
      [newData[itemIndex], newData[itemIndex - 1]] = [
        newData[itemIndex - 1],
        newData[itemIndex],
      ];
      newData = newData.map((item, index) => {
        return {
          ...item,
          index: index + 1,
        };
      });
      setDataBackup(newData);
    }
  };
  const dataSource = useMemo(() => {
    let result = [];
    const listUpdate = [];
    result = dataBackup?.map((item, index) => {
      listUpdate.push({ productId: item.id, index: index + 1 });
      return {
        ...item,
      };
    });
    setDataUpDate(listUpdate);
    return result;
  }, [dataBackup]);
  const columns = [
    {
      title: "Vị Trí",
      dataIndex: "index",
      key: "index",
      className: "centerCell",
      width: 90,
    },

    {
      title: <TranslateText text="Ảnh sản phẩm" />,
      dataIndex: "urlImage",
      key: "urlImage",
      className: "centerCell imgTable",
      render: (text, record) => (
        <Image
          style={{
            display: "block",
            objectFit: "contain",
          }}
          src={`${window.SERVER_URL}/${text}`}
          alt={`Image ${record.name}`}
          width={150}
          height={70}
        />
      ),
    },
    {
      title: <TranslateText text="Mã sản phẩm" />,
      dataIndex: "code",
      key: "code",
      className: "centerCell",
    },
    {
      title: <TranslateText text="Tên sản phẩm" />,
      dataIndex: "name",
      key: "name",
      className: "title collapseText centerCell",
    },

    {
      title: <TranslateText text="Chức năng" />,
      key: "action",
      dataIndex: "action",
      className: " centerCell",

      render: (text, record) => {
        return (
          <div
            className={dataBackup.length <= 1 ? "centerCell" : "evenSpace"}
            style={{ minWidth: "120px", height: "100%" }}
          >
            <span className="pointer iconTbl">
              {dataBackup.length <= 1 ? null : record.index === 1 ? (
                <IconArrowDown onClick={() => handleSortDown(record)} />
              ) : record.index === dataBackup.length ? (
                <IconArrowTop onClick={() => handleSortUp(record)} />
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <IconArrowTop
                    style={{ marginBottom: 5 }}
                    onClick={() => handleSortUp(record)}
                  />
                  <IconArrowDown onClick={() => handleSortDown(record)} />
                </div>
              )}
            </span>

            <span
              className="pointer iconTbl"
              onClick={() => {
                dispatch(deleteProductPin(record.id));
              }}
            >
              <Tooltip title="Xóa">
                <IconXmark />
              </Tooltip>
            </span>
          </div>
        );
      },
    },
  ];

  const tableLoading = {
    spinning: isLoading, // isLoading là biến boolean để xác định xem có đang loading hay không
    indicator: <IconSpin className="iconSpin" />,
  };
  return (
    <>
      <Row>
        <Col className="mr-5">
          <InputSearchBox
            setText={(value) => {
              setSearchText(value);
            }}
            width={435}
            placeholder={"Tìm kiếm theo tên sản phẩm"}
          />
        </Col>
        <Col style={{ flexGrow: 1, display: "flex", justifyContent: "end" }}>
          <BaseButton
            content={`Lưu`}
            width={120}
            typeBtn="btnOrange"
            icon={<IconSave />}
            handleClick={handleSaveConfig}
          />
        </Col>
      </Row>
      <Row style={{ width: "100%" }}>
        <Table
          loading={tableLoading}
          className="wrapperTblNewsPost"
          style={{ width: "100%", marginTop: "2.6rem" }}
          columns={columns}
          dataSource={dataSource}
          pagination={false}
        />
      </Row>
    </>
  );
};

export default TableConfigPageOneStore;
